module.exports = __webpack_public_path__ + "img/cs.8d3cdba9.jpg";